import { render, staticRenderFns } from "./PickupContent.vue?vue&type=template&id=0e081917&scoped=true&"
import script from "./PickupContent.vue?vue&type=script&lang=ts&"
export * from "./PickupContent.vue?vue&type=script&lang=ts&"
import style0 from "./PickupContent.vue?vue&type=style&index=0&id=0e081917&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e081917",
  null
  
)

export default component.exports